import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleStudentsNoAppUsageUseCaseInterface } from 'domain/usecases';
import { REPORT_TYPE } from 'domain/value-objects/report-type';

export class RemoteHandleStudentsNoAppUsage
  implements HandleStudentsNoAppUsageUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleStudentsNoAppUsageUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleStudentsNoAppUsageUseCaseInterface.Params,
  ): Promise<HandleStudentsNoAppUsageUseCaseInterface.Result> {
    const { reportType, ...restParams } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${reportType}`, restParams),
      responseType: reportType === REPORT_TYPE.JSON ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
